<zbp-modal-template
  [modalHeader]="editUserModalHeader"
  [bodyContent]="editUserModalBody"
  [footerContent]="editUserModalFooter"
  [isScrollable]="true"
  >
  <ng-template #editUserModalHeader>
    <h1 class="h2">Edit User - {{ userToEditOriginal?.firstName}} {{ userToEditOriginal?.lastName}} </h1>
    @if (roleToEdit === studentRoleType) {
      <h2 id="editUserLastActivity">Last Activity: <span class="last-activity-info">{{ userToEditOriginal?.lastActivityTime}}</span></h2>
    }
  </ng-template>

  <ng-template #editUserModalBody>
    @if (!isLoading) {
      <div id="editUserModalContainer" class="modal-template">
        @if (userToEditOriginal && formGroupContainer) {
          <form id="editUserForm" [formGroup]="formGroupContainer" (ngSubmit)="save()">
            <zbp-branded-manage-users-form
              [roleType]="roleToEdit"
              [school]="currentSchool"
              [canAddMultipleUsers]="false"
              [usersAndRoleGroupName]="editUserGroupName"
              [hideFirstRowDeleteButton]="true"
              [canUserSearch]="false"
              [includeUserId]="false"
              [formMode]="editFormMode"
              addAnotherUserLabel="Add Parent"
              [user]="userToEditOriginal"
              [trackSelectedUser]="updateSelectedUser"
              [hasUnsavedChanges]="hasUnsavedChanges"
              (bypassUnsavedChanges)="handleBypassUnsavedChanges($event)"
              >
            </zbp-branded-manage-users-form>
          </form>
        }
      </div>
    }
  </ng-template>

  <ng-template #editUserModalFooter>
    <!-- Show unsaved changes message when editing a user -->
    @if (hasUnsavedChanges | async) {
      <p id="unsaved-changes-text">You have unsaved changes!</p>
    }
    <zbp-button-component
      theme="ghost"
      label="Cancel"
      (click)="dismiss()"
      type="button"
      [disabled]="isSaving"
      class="text-uppercase">
    </zbp-button-component>
    <zbp-button-component
      [formId]="'editUserForm'"
      internalId="editUserSubmitButton"
      type="submit"
      theme="primary"
      label="Save"
      [extraHorizontalPadding]="true"
      [showSpinner]="isSaving"
      [disabled]="isSaving || formGroupContainer.invalid || (hasUnsavedChanges | async) === false"
      class="text-uppercase ms-2">
    </zbp-button-component>
  </ng-template>

</zbp-modal-template>
